import { APIError } from 'data/Provider';
import React, { FC } from 'react';
import { Alert } from 'reactstrap';

export interface AlertProps {
    error?: APIError;
    alertType: 'warning' | 'danger' | 'success' | 'info';
    showAlert: boolean;
}

const ErrorAlert: FC<AlertProps> = (
    {
        error,
        alertType,
        showAlert,
        ...rest
    }) => (
    <div className="content-wrapper py-0">
        <Alert
            isOpen={showAlert}
            color={alertType}
            className="mt-2 py-2"
        >
            <div className='d-block d-md-flex pt-2'>
                <div className='col-auto text-center ms-3'>
                    <i className='bi bi-exclamation-triangle me-3' style={{ fontSize: '4rem' }}></i>
                </div>
                <div className='col-auto mx-auto'>
                    {error &&
                        <>
                            <h3>{error.title}</h3>
                            {/* <h5>{error.errorDetails?.message}</h5> */}
                        </>
                    }
                    <div className='mt-3'>Please try to reload the page or try the application later. Thank you.</div>
                </div>

            </div>
        </Alert>
    </div >
);

export default ErrorAlert;
